import { render, staticRenderFns } from "./TrademarkProvisionalForm.vue?vue&type=template&id=40809e66&"
import script from "./TrademarkProvisionalForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkProvisionalForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkProvisionalForm.vue?vue&type=style&index=0&id=40809e66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports